import { createImageUrlBuilder } from '@sanity/image-url'
import client from '../../components/sanityProject/sanityClient'

const builder = createImageUrlBuilder(client)

export function urlFor(source) {
  return builder.image(source)
}